import { makeInMemoryVar } from '@apollo-internal/inMemoryVar';

export const STORAGE_KEYS = {
  SESSION_DURATION: 'session-duration'
};

export const secondsToExpire = makeInMemoryVar(STORAGE_KEYS.SESSION_DURATION, {});

export const secondsToExpireCache = {
  secondsToExpire: {
    read: secondsToExpire
  }
};
